import { createClient } from '@/shared/api';
import type { GetEvaluationEventMutation, GetEvaluationEventMutationVariables } from '@/shared/api';
import GET_EVALUATION_EVENT_MUTATION from '../mutations/getEvaluationEvent';

/**
 * Requests an evaluation event for a study. Runs GET_EVALUATION_EVENT_MUTATION, throws getEvaluationEvent.message when isSuccess is false, and returns the payload.
 *
 * @param studyId - Identifier of the study to evaluate.
 * @returns The getEvaluationEvent payload.
 */
const handleGetEvaluationEvent = async (studyId: any) => {
  const client = createClient();
  const result = await client.mutate<
    GetEvaluationEventMutation,
    GetEvaluationEventMutationVariables
  >({
    mutation: GET_EVALUATION_EVENT_MUTATION,
    variables: {
      studyId,
    },
  });
  const { data } = result;
  const { getEvaluationEvent } = data ?? {};
  if (!getEvaluationEvent?.isSuccess) {
    throw new Error(getEvaluationEvent?.message ?? undefined);
  }
  return getEvaluationEvent;
};

export default handleGetEvaluationEvent;
